// One measurement event per successful form request. The API id doubles as the deduplication id
// for browser and server-side conversions; newsletter sign-ups are not counted as leads.
const formTypes = { demo: 'demo', book_demo: 'demo', price_stepper: 'quote', contact: 'contact', subscribe_mail: 'newsletter' };

function text(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed || null;
}

export function resolveFormType(requestType) {
  const key = text(requestType)?.toLowerCase() || '';
  return formTypes[key] || key || 'demo';
}

export function buildLeadEvent({ requestType, source, requestId, pagePath, firstTouch } = {}) {
  const formType = resolveFormType(requestType);
  const id = requestId === null || requestId === undefined ? null : String(requestId);
  const params = {
    form_type: formType,
    request_type: text(requestType) || 'demo',
    lead_source: text(source),
    request_id: id,
    event_id: id ? 'lead_' + id : null,
    page_path: text(pagePath),
    first_touch: firstTouch && typeof firstTouch === 'object' ? firstTouch : null,
  };
  return {
    name: formType === 'newsletter' ? 'newsletter_subscribe' : 'generate_lead',
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => value !== null)),
  };
}
